import { Divider } from '@neo4j-ndl/react';
import type { DbmsInfo, DbmsPlugin } from '@nx/state/desktop';
import { useListAvailablePluginsQuery, useListInstalledPluginsQuery } from '@nx/state/desktop';
import { isNotNullish } from '@nx/stdlib';

import { Plugin } from './plugin';
import { PLUGINS_INFO } from './plugins-info';

export function Plugins({ instance }: { instance: DbmsInfo }) {
  const installedPlugins = useListInstalledPluginsQuery(instance.id);
  const availablePlugins = useListAvailablePluginsQuery(instance.id);

  const plugins: Record<string, DbmsPlugin & { isInstalled: boolean }> = {};
  if (availablePlugins.isSuccess) {
    availablePlugins.data.forEach((plugin) => {
      plugins[plugin.name] = { ...plugin, isInstalled: false };
    });
  }

  if (installedPlugins.isSuccess) {
    installedPlugins.data.forEach((plugin) => {
      plugins[plugin.name] = { ...plugin, isInstalled: true };
    });
  }

  return (
    Object.entries(plugins)
      // Sort the plugins alphabetically, but keeping the plugins that have info
      // at the top.
      .sort(([a], [b]) => {
        const aHasInfo = isNotNullish(PLUGINS_INFO[a]);
        const bHasInfo = isNotNullish(PLUGINS_INFO[b]);

        if (a < b || (aHasInfo && !bHasInfo)) {
          return -1;
        }

        if (a > b || (!aHasInfo && bHasInfo)) {
          return 1;
        }

        return 0;
      })
      .map(([pluginId, plugin]) => (
        <div key={pluginId}>
          <Plugin loading={installedPlugins.isFetching} instance={instance} plugin={plugin} pluginId={pluginId} />
          <Divider orientation="horizontal" />
        </div>
      ))
  );
}
